// extracted by mini-css-extract-plugin
export var button = "_jo-0";
export var donut = "_jo-1";
export var donutFill = "_jo-3";
export var donutTrack = "_jo-2";